import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';

const Icon = createSvgIcon(
  <svg viewBox='0 0 24 24' fill='none' color='inherit' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M 12.5 11 L 12.5 4 L 4 4 L 4 17.175 L 5.175 16 L 20 16 L 20 4 L 17.5 4 L 17.5 11 L 15 9.5 L 12.5 11 Z M 2 22 L 2 4 C 2 3.45 2.196 2.979 2.587 2.587 C 2.979 2.196 3.45 2 4 2 L 20 2 C 20.55 2 21.021 2.196 21.412 2.587 C 21.804 2.979 22 3.45 22 4 L 22 16 C 22 16.55 21.804 17.021 21.412 17.412 C 21.021 17.804 20.55 18 20 18 L 6 18 L 2 22 Z'
      fill='currentColor'
    />
  </svg>,
  'CommentBankClassic',
);

const ColoredIcon = styled(Icon)(({ theme, color }) => ({
  color: parseColor(theme, color),
}));

export default ColoredIcon;
